import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { recruitingStatusQuerySchema } from './recruiting-status-query-schema';

export const recruitingStatusFormSchema = recruitingStatusQuerySchema.omit({ name: true, status: true }).extend({
  name: z.string().min(1),
  status: statusFormSchema,
});

export type RecruitingStatusFormSchema = z.infer<typeof recruitingStatusFormSchema>;
